export const filterConstants = Object.freeze({
    orgApplications: {
        defaultItemsPerPage: 10,
        fromDateMonths: 3
    }
});